import React from "react";

import useBreakpoint from "use-breakpoint";

import useGlobalStore from "@/stores/useGlobalStore";
import { BREAKPOINTS } from "@/constants/defaultValue";
import BusinessSwitcher from "@/components/BusinessSwitcher";

import HeaderNewChat from "./NewChatBtn";
import OpenSidebar from "./OpenSideBarBtn";
import AIModelSwitcher from "./AIModelSwitcher";
import SuggestionButton from "./SuggestionButton";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Header = ({ isBack, title }) => {
  const { navVisible, user, business } = useGlobalStore();
  const { breakpoint } = useBreakpoint(BREAKPOINTS);
  const isMobile = ["xs", "sm"].includes(breakpoint);
  const navigate = useNavigate();

  return (
    <div className={`sticky top-0 z-10 w-full items-center justify-between p-3 font-semibold text-text-primary dark:bg-gray-800 ${isMobile ? "shadow-sm" : ""}`}>
      <div className="hide-scrollbar flex w-full items-center justify-between gap-2 overflow-x-auto h-12">
        {isBack && isMobile ? (
          <div className="flex items-center gap-2">
            <button
              onClick={() => {
                const canGoBack = (window.history.state?.idx || 0) > 0;
                if (canGoBack) {
                  navigate(-1);
                } else {
                  navigate("/");
                }
              }}
            >
              <ArrowLeft size={32} strokeWidth={1.5} />
            </button>
            <span className="text-lg font-medium text-center">{title || "Trợ lý AI"}</span>
          </div>
        ) : (
          <>
            {((isMobile && !navVisible) || !isMobile) && (
              <div className="mx-1 flex items-center gap-2">
                <OpenSidebar navVisible={!navVisible} tooltipContent={"Open Sidebar"} />
                <HeaderNewChat navVisible={!navVisible} />
                <AIModelSwitcher isMobile={isMobile} />
              </div>
            )}
            <div className="flex items-center ">
              <SuggestionButton />
              <BusinessSwitcher isMobile={isMobile} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
